<template xmlns="http://www.w3.org/1999/html">
  <main class="wrapper">
    <section class="information">
    <p>
      Для автоматик серий KO, GW, HK, MW при установке модуля <span class="green">VITOCOM LAN</span> доступны контроль и диагностирование установкой через интернет. (Необходимо проводное соединение с сетью) <span class="red">Стоимость работ по установке модуля и регистрации в сети - 4500 руб.</span>
    </p>
    <p>
      Для управления установками через мобильный телефон или планшет необходимо установить программу <span class="green">VITOTROL</span>.
    </p>
    <p>
      На главной странице приложения отображается наружная температура и температура, заданная в помещении. Помимо этого вы можете видеть программу, в которой сейчас работает система отопления, дату и время. Все изменения в работе установки вводятся интерактивно через приложение. Например, вы можете продлить дневной режим работы отопления или переключиться в режим экономии.
    </p>
    </section>
    <section class="vitotrolImages">
      <figure>
        <img src="../img/vitotrol1.webp" alt="главная страница витотрол">
        <figcaption>Главная страница VITOTROL</figcaption>
      </figure>
      <figure>
        <img src="../img/vitotrol2.webp" alt="меню приложения витотрол">
        <figcaption>Меню приложения VITOTROL</figcaption>
      </figure>
    </section>
    <section class="information">
      <p style="text-align: center; text-indent: 0">
        Также установками можно <span class="green">управлять через сайт</span>:
      </p>
      <p style="text-align: center; text-indent: 0">
        <a href="https://vitodata100.viessmann.com/VD100/VD100/Login/Login.aspx" target="_blank">страница управления</a>
      </p>
      <p>
        При наличии договора с пользователем, сервисная служба <b>ОБЛГАЗСЕРВИС-СЕВЕР</b>  может в режиме реального времени контролировать установки. На экране диспетчера отображается состояние установок; все ошибки с установки
        будут отправлены на эл.почту и отображены на экране. На телефон/планшет сообщения будут приходить в виде push-уведомлений.
      </p>
      <div id="controlUI">
        <figure>
          <img src="../img/controlUI.webp" alt="интерфейс диспетчера">
          <figcaption>Интерфейс диспетчера</figcaption>
        </figure>
      </div>
    </section>
  </main>
</template>

<script>
  export default {

  }
</script>

<style scoped>

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.vitotrolImages {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 1600px;
  height: 70vh;
  margin-bottom: 50px;
}

figure {
  text-align: center;
}

figcaption {
  font-size: 2em;
  margin-bottom: 30px;
}

img {
  width: 80%;
  height: 100%;
}

p {
  font-size: 2em;
  text-indent: 50px;
  padding: 10px;
  margin-right: 5%;
  margin-left: 5%;
}

a {
  font-size: 1.2em;
}

@media (max-width: 1400px) {
  .vitotrolImages {
    flex-direction: column;
    width: 100%;
    height: auto;
  }
  img {
    width: 40%;
    height: 100%;
  }

  #controlUI {
    display: none;
  }
}

@media (max-width: 800px) {
  p {
    font-size: 1.2em;
  }
}

@media (max-width: 600px) {
  p {
    font-size: 1em;
  }

  img {
    width: 100%;
  }

  .vitotrolImages {
    margin-bottom: 0;
  }

  figcaption {
    font-size: 1.5em;
  }
}

</style>